import { all, call, put, select, take } from 'redux-saga/effects';
import { UPDATE_USER } from './types';
import { requestHandler } from '../fetcher.saga';

export function* setUser(decodedAccessToken, token) {
	const user = {
		id: decodedAccessToken.id,
		token: token,
		username: decodedAccessToken.username,
		email: decodedAccessToken.email,
		isPartner: decodedAccessToken.type === 'partner',
		partnerPrefix: decodedAccessToken.partnerPrefix,
		account_id: decodedAccessToken.account_id,
	};
	yield put({ type: UPDATE_USER, user });
}

export function* updateMask() {
	while (true) {
		const { mask_name, partner_prefix, active, id } = yield take(
			'UPDATE_MASK_OPTION'
		);

		const { result } = yield call(
			requestHandler,
			'user',
			'PATCH',
			{ mask_name, partner_prefix, active, id },
			'mask'
		);

		yield put({
			type: UPDATE_USER,
			user: { masks: result },
		});
	}
}

export function* isPartner() {
	let state = yield select();

	if (state && state.service && state.service.user) {
		return state.service.user.isPartner || false;
	}
	return false;
}

export default function* userSaga() {
	yield all([updateMask()]);
}
